/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StationsIndexRouteImport } from './routes/stations/index'
import { Route as PresetsIndexRouteImport } from './routes/presets/index'
import { Route as MapIndexRouteImport } from './routes/map/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminUserGroupsRouteImport } from './routes/admin/user-groups'
import { Route as AdminStationTagsRouteImport } from './routes/admin/station-tags'
import { Route as AdminScreenPresetsRouteImport } from './routes/admin/screen-presets'
import { Route as AdminRelayConfigsRouteImport } from './routes/admin/relay-configs'
import { Route as AdminOrgsRouteImport } from './routes/admin/orgs'
import { Route as AdminModsConfigsRouteImport } from './routes/admin/mods-configs'
import { Route as AdminAppsRouteImport } from './routes/admin/apps'
import { Route as AdminAmpfConfigsRouteImport } from './routes/admin/ampf-configs'
import { Route as DashboardTemperaturesUnitSerialNumberRouteImport } from './routes/dashboard/temperatures/$unitSerialNumber'
import { Route as StationsClassicStationIdIndexRouteImport } from './routes/stations/classic/$stationId/index'

const TargetsIndexLazyRouteImport = createFileRoute('/targets/')()
const StationAccessIndexLazyRouteImport = createFileRoute('/station-access/')()
const SettingsIndexLazyRouteImport = createFileRoute('/settings/')()
const EventsIndexLazyRouteImport = createFileRoute('/events/')()
const AnalyticsIndexLazyRouteImport = createFileRoute('/analytics/')()
const StationsSingleStationIdIndexLazyRouteImport = createFileRoute(
  '/stations/single/$stationId/',
)()

const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin/route.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TargetsIndexLazyRoute = TargetsIndexLazyRouteImport.update({
  id: '/targets/',
  path: '/targets/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/targets/index.lazy').then((d) => d.Route))
const StationAccessIndexLazyRoute = StationAccessIndexLazyRouteImport.update({
  id: '/station-access/',
  path: '/station-access/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/station-access/index.lazy').then((d) => d.Route),
)
const SettingsIndexLazyRoute = SettingsIndexLazyRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/settings/index.lazy').then((d) => d.Route),
)
const EventsIndexLazyRoute = EventsIndexLazyRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/events/index.lazy').then((d) => d.Route))
const AnalyticsIndexLazyRoute = AnalyticsIndexLazyRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/analytics/index.lazy').then((d) => d.Route),
)
const StationsIndexRoute = StationsIndexRouteImport.update({
  id: '/stations/',
  path: '/stations/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/stations/index.lazy').then((d) => d.Route),
)
const PresetsIndexRoute = PresetsIndexRouteImport.update({
  id: '/presets/',
  path: '/presets/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/presets/index.lazy').then((d) => d.Route))
const MapIndexRoute = MapIndexRouteImport.update({
  id: '/map/',
  path: '/map/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/map/index.lazy').then((d) => d.Route))
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login/index.lazy').then((d) => d.Route))
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/dashboard/index.lazy').then((d) => d.Route),
)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() => import('./routes/admin/index.lazy').then((d) => d.Route))
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() => import('./routes/admin/users.lazy').then((d) => d.Route))
const AdminUserGroupsRoute = AdminUserGroupsRouteImport.update({
  id: '/user-groups',
  path: '/user-groups',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/user-groups.lazy').then((d) => d.Route),
)
const AdminStationTagsRoute = AdminStationTagsRouteImport.update({
  id: '/station-tags',
  path: '/station-tags',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/station-tags.lazy').then((d) => d.Route),
)
const AdminScreenPresetsRoute = AdminScreenPresetsRouteImport.update({
  id: '/screen-presets',
  path: '/screen-presets',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/screen-presets.lazy').then((d) => d.Route),
)
const AdminRelayConfigsRoute = AdminRelayConfigsRouteImport.update({
  id: '/relay-configs',
  path: '/relay-configs',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/relay-configs.lazy').then((d) => d.Route),
)
const AdminOrgsRoute = AdminOrgsRouteImport.update({
  id: '/orgs',
  path: '/orgs',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() => import('./routes/admin/orgs.lazy').then((d) => d.Route))
const AdminModsConfigsRoute = AdminModsConfigsRouteImport.update({
  id: '/mods-configs',
  path: '/mods-configs',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/mods-configs.lazy').then((d) => d.Route),
)
const AdminAppsRoute = AdminAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAmpfConfigsRoute = AdminAmpfConfigsRouteImport.update({
  id: '/ampf-configs',
  path: '/ampf-configs',
  getParentRoute: () => AdminRouteRoute,
} as any).lazy(() =>
  import('./routes/admin/ampf-configs.lazy').then((d) => d.Route),
)
const DashboardTemperaturesUnitSerialNumberRoute =
  DashboardTemperaturesUnitSerialNumberRouteImport.update({
    id: '/dashboard/temperatures/$unitSerialNumber',
    path: '/dashboard/temperatures/$unitSerialNumber',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/dashboard/temperatures/$unitSerialNumber.lazy').then(
      (d) => d.Route,
    ),
  )
const StationsSingleStationIdIndexLazyRoute =
  StationsSingleStationIdIndexLazyRouteImport.update({
    id: '/stations/single/$stationId/',
    path: '/stations/single/$stationId/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/stations/single/$stationId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const StationsClassicStationIdIndexRoute =
  StationsClassicStationIdIndexRouteImport.update({
    id: '/stations/classic/$stationId/',
    path: '/stations/classic/$stationId/',
    getParentRoute: () => rootRouteImport,
  } as any).lazy(() =>
    import('./routes/stations/classic/$stationId/index.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/admin/ampf-configs': typeof AdminAmpfConfigsRoute
  '/admin/apps': typeof AdminAppsRoute
  '/admin/mods-configs': typeof AdminModsConfigsRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/admin/relay-configs': typeof AdminRelayConfigsRoute
  '/admin/screen-presets': typeof AdminScreenPresetsRoute
  '/admin/station-tags': typeof AdminStationTagsRoute
  '/admin/user-groups': typeof AdminUserGroupsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/login': typeof LoginIndexRoute
  '/map': typeof MapIndexRoute
  '/presets': typeof PresetsIndexRoute
  '/stations': typeof StationsIndexRoute
  '/analytics': typeof AnalyticsIndexLazyRoute
  '/events': typeof EventsIndexLazyRoute
  '/settings': typeof SettingsIndexLazyRoute
  '/station-access': typeof StationAccessIndexLazyRoute
  '/targets': typeof TargetsIndexLazyRoute
  '/dashboard/temperatures/$unitSerialNumber': typeof DashboardTemperaturesUnitSerialNumberRoute
  '/stations/classic/$stationId': typeof StationsClassicStationIdIndexRoute
  '/stations/single/$stationId': typeof StationsSingleStationIdIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin/ampf-configs': typeof AdminAmpfConfigsRoute
  '/admin/apps': typeof AdminAppsRoute
  '/admin/mods-configs': typeof AdminModsConfigsRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/admin/relay-configs': typeof AdminRelayConfigsRoute
  '/admin/screen-presets': typeof AdminScreenPresetsRoute
  '/admin/station-tags': typeof AdminStationTagsRoute
  '/admin/user-groups': typeof AdminUserGroupsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/login': typeof LoginIndexRoute
  '/map': typeof MapIndexRoute
  '/presets': typeof PresetsIndexRoute
  '/stations': typeof StationsIndexRoute
  '/analytics': typeof AnalyticsIndexLazyRoute
  '/events': typeof EventsIndexLazyRoute
  '/settings': typeof SettingsIndexLazyRoute
  '/station-access': typeof StationAccessIndexLazyRoute
  '/targets': typeof TargetsIndexLazyRoute
  '/dashboard/temperatures/$unitSerialNumber': typeof DashboardTemperaturesUnitSerialNumberRoute
  '/stations/classic/$stationId': typeof StationsClassicStationIdIndexRoute
  '/stations/single/$stationId': typeof StationsSingleStationIdIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/admin/ampf-configs': typeof AdminAmpfConfigsRoute
  '/admin/apps': typeof AdminAppsRoute
  '/admin/mods-configs': typeof AdminModsConfigsRoute
  '/admin/orgs': typeof AdminOrgsRoute
  '/admin/relay-configs': typeof AdminRelayConfigsRoute
  '/admin/screen-presets': typeof AdminScreenPresetsRoute
  '/admin/station-tags': typeof AdminStationTagsRoute
  '/admin/user-groups': typeof AdminUserGroupsRoute
  '/admin/users': typeof AdminUsersRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/login/': typeof LoginIndexRoute
  '/map/': typeof MapIndexRoute
  '/presets/': typeof PresetsIndexRoute
  '/stations/': typeof StationsIndexRoute
  '/analytics/': typeof AnalyticsIndexLazyRoute
  '/events/': typeof EventsIndexLazyRoute
  '/settings/': typeof SettingsIndexLazyRoute
  '/station-access/': typeof StationAccessIndexLazyRoute
  '/targets/': typeof TargetsIndexLazyRoute
  '/dashboard/temperatures/$unitSerialNumber': typeof DashboardTemperaturesUnitSerialNumberRoute
  '/stations/classic/$stationId/': typeof StationsClassicStationIdIndexRoute
  '/stations/single/$stationId/': typeof StationsSingleStationIdIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/admin/ampf-configs'
    | '/admin/apps'
    | '/admin/mods-configs'
    | '/admin/orgs'
    | '/admin/relay-configs'
    | '/admin/screen-presets'
    | '/admin/station-tags'
    | '/admin/user-groups'
    | '/admin/users'
    | '/admin/'
    | '/dashboard'
    | '/login'
    | '/map'
    | '/presets'
    | '/stations'
    | '/analytics'
    | '/events'
    | '/settings'
    | '/station-access'
    | '/targets'
    | '/dashboard/temperatures/$unitSerialNumber'
    | '/stations/classic/$stationId'
    | '/stations/single/$stationId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin/ampf-configs'
    | '/admin/apps'
    | '/admin/mods-configs'
    | '/admin/orgs'
    | '/admin/relay-configs'
    | '/admin/screen-presets'
    | '/admin/station-tags'
    | '/admin/user-groups'
    | '/admin/users'
    | '/admin'
    | '/dashboard'
    | '/login'
    | '/map'
    | '/presets'
    | '/stations'
    | '/analytics'
    | '/events'
    | '/settings'
    | '/station-access'
    | '/targets'
    | '/dashboard/temperatures/$unitSerialNumber'
    | '/stations/classic/$stationId'
    | '/stations/single/$stationId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/admin/ampf-configs'
    | '/admin/apps'
    | '/admin/mods-configs'
    | '/admin/orgs'
    | '/admin/relay-configs'
    | '/admin/screen-presets'
    | '/admin/station-tags'
    | '/admin/user-groups'
    | '/admin/users'
    | '/admin/'
    | '/dashboard/'
    | '/login/'
    | '/map/'
    | '/presets/'
    | '/stations/'
    | '/analytics/'
    | '/events/'
    | '/settings/'
    | '/station-access/'
    | '/targets/'
    | '/dashboard/temperatures/$unitSerialNumber'
    | '/stations/classic/$stationId/'
    | '/stations/single/$stationId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  MapIndexRoute: typeof MapIndexRoute
  PresetsIndexRoute: typeof PresetsIndexRoute
  StationsIndexRoute: typeof StationsIndexRoute
  AnalyticsIndexLazyRoute: typeof AnalyticsIndexLazyRoute
  EventsIndexLazyRoute: typeof EventsIndexLazyRoute
  SettingsIndexLazyRoute: typeof SettingsIndexLazyRoute
  StationAccessIndexLazyRoute: typeof StationAccessIndexLazyRoute
  TargetsIndexLazyRoute: typeof TargetsIndexLazyRoute
  DashboardTemperaturesUnitSerialNumberRoute: typeof DashboardTemperaturesUnitSerialNumberRoute
  StationsClassicStationIdIndexRoute: typeof StationsClassicStationIdIndexRoute
  StationsSingleStationIdIndexLazyRoute: typeof StationsSingleStationIdIndexLazyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/targets/': {
      id: '/targets/'
      path: '/targets'
      fullPath: '/targets'
      preLoaderRoute: typeof TargetsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/station-access/': {
      id: '/station-access/'
      path: '/station-access'
      fullPath: '/station-access'
      preLoaderRoute: typeof StationAccessIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/analytics/': {
      id: '/analytics/'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AnalyticsIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stations/': {
      id: '/stations/'
      path: '/stations'
      fullPath: '/stations'
      preLoaderRoute: typeof StationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/presets/': {
      id: '/presets/'
      path: '/presets'
      fullPath: '/presets'
      preLoaderRoute: typeof PresetsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/map/': {
      id: '/map/'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof MapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/user-groups': {
      id: '/admin/user-groups'
      path: '/user-groups'
      fullPath: '/admin/user-groups'
      preLoaderRoute: typeof AdminUserGroupsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/station-tags': {
      id: '/admin/station-tags'
      path: '/station-tags'
      fullPath: '/admin/station-tags'
      preLoaderRoute: typeof AdminStationTagsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/screen-presets': {
      id: '/admin/screen-presets'
      path: '/screen-presets'
      fullPath: '/admin/screen-presets'
      preLoaderRoute: typeof AdminScreenPresetsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/relay-configs': {
      id: '/admin/relay-configs'
      path: '/relay-configs'
      fullPath: '/admin/relay-configs'
      preLoaderRoute: typeof AdminRelayConfigsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/orgs': {
      id: '/admin/orgs'
      path: '/orgs'
      fullPath: '/admin/orgs'
      preLoaderRoute: typeof AdminOrgsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/mods-configs': {
      id: '/admin/mods-configs'
      path: '/mods-configs'
      fullPath: '/admin/mods-configs'
      preLoaderRoute: typeof AdminModsConfigsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/apps': {
      id: '/admin/apps'
      path: '/apps'
      fullPath: '/admin/apps'
      preLoaderRoute: typeof AdminAppsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/ampf-configs': {
      id: '/admin/ampf-configs'
      path: '/ampf-configs'
      fullPath: '/admin/ampf-configs'
      preLoaderRoute: typeof AdminAmpfConfigsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/dashboard/temperatures/$unitSerialNumber': {
      id: '/dashboard/temperatures/$unitSerialNumber'
      path: '/dashboard/temperatures/$unitSerialNumber'
      fullPath: '/dashboard/temperatures/$unitSerialNumber'
      preLoaderRoute: typeof DashboardTemperaturesUnitSerialNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stations/single/$stationId/': {
      id: '/stations/single/$stationId/'
      path: '/stations/single/$stationId'
      fullPath: '/stations/single/$stationId'
      preLoaderRoute: typeof StationsSingleStationIdIndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stations/classic/$stationId/': {
      id: '/stations/classic/$stationId/'
      path: '/stations/classic/$stationId'
      fullPath: '/stations/classic/$stationId'
      preLoaderRoute: typeof StationsClassicStationIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAmpfConfigsRoute: typeof AdminAmpfConfigsRoute
  AdminAppsRoute: typeof AdminAppsRoute
  AdminModsConfigsRoute: typeof AdminModsConfigsRoute
  AdminOrgsRoute: typeof AdminOrgsRoute
  AdminRelayConfigsRoute: typeof AdminRelayConfigsRoute
  AdminScreenPresetsRoute: typeof AdminScreenPresetsRoute
  AdminStationTagsRoute: typeof AdminStationTagsRoute
  AdminUserGroupsRoute: typeof AdminUserGroupsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAmpfConfigsRoute: AdminAmpfConfigsRoute,
  AdminAppsRoute: AdminAppsRoute,
  AdminModsConfigsRoute: AdminModsConfigsRoute,
  AdminOrgsRoute: AdminOrgsRoute,
  AdminRelayConfigsRoute: AdminRelayConfigsRoute,
  AdminScreenPresetsRoute: AdminScreenPresetsRoute,
  AdminStationTagsRoute: AdminStationTagsRoute,
  AdminUserGroupsRoute: AdminUserGroupsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  MapIndexRoute: MapIndexRoute,
  PresetsIndexRoute: PresetsIndexRoute,
  StationsIndexRoute: StationsIndexRoute,
  AnalyticsIndexLazyRoute: AnalyticsIndexLazyRoute,
  EventsIndexLazyRoute: EventsIndexLazyRoute,
  SettingsIndexLazyRoute: SettingsIndexLazyRoute,
  StationAccessIndexLazyRoute: StationAccessIndexLazyRoute,
  TargetsIndexLazyRoute: TargetsIndexLazyRoute,
  DashboardTemperaturesUnitSerialNumberRoute:
    DashboardTemperaturesUnitSerialNumberRoute,
  StationsClassicStationIdIndexRoute: StationsClassicStationIdIndexRoute,
  StationsSingleStationIdIndexLazyRoute: StationsSingleStationIdIndexLazyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
